import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withKeys as _withKeys, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6294f45e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "todo-list-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "Subgruppe löschen", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "Neuen Ordner hinzufügen", -1))
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-center justify-end"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fertige Todos", -1))
const _hoisted_6 = { class: "d-flex align-center justify-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fertige Todos", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onDblclick"]
const _hoisted_12 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_icon = _resolveComponent("v-list-item-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "3",
                class: "v-col-xl-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_toolbar_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Todo Listen")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { class: "lists-container d-flex flex-column" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topLevelTodoLists, (list) => {
                                return (_openBlock(), _createBlock(_component_v_list_group, {
                                  key: list.id
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_content, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(list.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSubLists(list.id), (subList) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: subList.id,
                                        onClick: _withModifiers(($event: any) => (_ctx.selectList(subList)), ["stop"]),
                                        class: _normalizeClass({ active: _ctx.isActiveList(subList) })
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            icon: "$close",
                                            size: "medium",
                                            variant: "text",
                                            onClick: _withModifiers(($event: any) => (_ctx.showDeleteSubListDialog(subList)), ["stop"])
                                          }, null, 8, ["onClick"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_content, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(subList.name), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick", "class"]))
                                    }), 128)),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.newSubGroup,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newSubGroup) = $event)),
                                      label: "Neue Subgruppe hinzufügen...",
                                      onKeyup: _withKeys(($event: any) => (_ctx.createSubList(list.id)), ["enter"]),
                                      "prepend-inner-icon": "mdi-plus",
                                      variant: "underlined"
                                    }, null, 8, ["modelValue", "onKeyup"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              _createVNode(_component_v_dialog, {
                                modelValue: _ctx.deleteSubListDialog.show,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deleteSubListDialog.show) = $event)),
                                "max-width": "400"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, null, {
                                        default: _withCtx(() => [
                                          _hoisted_2
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Bist du sicher, dass du diese Subgruppe löschen möchtest? ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_actions, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_btn, {
                                            color: "blue darken-1",
                                            text: "",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteSubListDialog.show = false))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Abbrechen ")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_btn, {
                                            color: "blue darken-1",
                                            text: "",
                                            onClick: _ctx.deleteSubList
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Löschen ")
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCreateListDialog = true))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode("mdi-plus")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" Neuen Ordner hinzufügen ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_dialog, {
                            modelValue: _ctx.showCreateListDialog,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showCreateListDialog) = $event)),
                            "max-width": "400"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, null, {
                                    default: _withCtx(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_container, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field, {
                                                    modelValue: _ctx.newListName,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newListName) = $event)),
                                                    label: "Ordnername"
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_btn, {
                                        color: "blue darken-1",
                                        text: "",
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCreateListDialog = false))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Abbrechen ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_btn, {
                                        color: "blue darken-1",
                                        text: "",
                                        onClick: _ctx.createList
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Erstellen ")
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            icon: "mdi-menu",
                            disabled: ""
                          }),
                          _createVNode(_component_v_toolbar_title, null, {
                            default: _withCtx(() => [
                              (_ctx.editingField.type !== 'listName')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    onDblclick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startEditingField('listName', _ctx.selectedList ? _ctx.selectedList.id : -1)))
                                  }, _toDisplayString(_ctx.selectedList ? _ctx.selectedList.name : ''), 33))
                                : (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 1,
                                    modelValue: _ctx.editedValue,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editedValue) = $event)),
                                    "single-line": "",
                                    onKeydown: [
                                      _withKeys(_ctx.updateField, ["enter"]),
                                      _withKeys(_ctx.cancelEditingField, ["esc"])
                                    ],
                                    onBlur: _ctx.cancelEditingField,
                                    ref: "editField",
                                    class: "mt-5 mr-5"
                                  }, null, 8, ["modelValue", "onKeydown", "onBlur"]))
                            ]),
                            _: 1
                          }),
                          (_ctx.isSelectedList())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _hoisted_5,
                                _createVNode(_component_v_switch, {
                                  modelValue: _ctx.showCompletedTodos,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showCompletedTodos) = $event)),
                                  class: "d-flex align-center ml-3 mr-3"
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { class: "todos-container" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unfinishedTodos, (todo) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: todo.id,
                                  onClick: ($event: any) => (_ctx.selectTodo(todo)),
                                  class: _normalizeClass({ active: _ctx.isActiveTodo(todo) }),
                                  style: _normalizeStyle(_ctx.getDueDateStyle(todo.due_date))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      align: "center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "auto" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: todo.completed,
                                              "onUpdate:modelValue": ($event: any) => ((todo.completed) = $event),
                                              "hide-details": "",
                                              onChange: ($event: any) => (_ctx.updateTodoCompletionStatus(todo)),
                                              style: _normalizeStyle(todo.importance == 'low' ? 'color:green' : todo.importance == 'medium' ? 'color:orange' : 'color:red')
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "style"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, {
                                              class: _normalizeClass(todo.completed ? 'text-decoration-line-through' : '')
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(todo.title), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["class"]),
                                            (_ctx.isSelectedList() && todo.all_checkboxes_count != 0)
                                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(todo.completed_checkboxes_count + "/" + todo.all_checkboxes_count) + " abgeschlossen ", 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, { class: "text-right d-flex align-center justify-end" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatDateToDDMMYYYY(todo.due_date)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "class", "style"]))
                              }), 128)),
                              (_ctx.isSelectedList())
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    modelValue: _ctx.newTodoTitle,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newTodoTitle) = $event)),
                                    label: "Neues Todo hinzufügen...",
                                    onKeyup: _withKeys(_ctx.createTodo, ["enter"]),
                                    "prepend-inner-icon": "mdi-plus",
                                    variant: "underlined"
                                  }, null, 8, ["modelValue", "onKeyup"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "5" }, {
                default: _withCtx(() => [
                  (_ctx.selectedTodo)
                    ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_toolbar, {
                            dense: "",
                            flat: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_toolbar_title, null, {
                                default: _withCtx(() => [
                                  (_ctx.editingField.type !== 'todoTitle')
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        onDblclick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.startEditingField('todoTitle', _ctx.selectedTodo ? _ctx.selectedTodo.id : -1)))
                                      }, _toDisplayString(_ctx.selectedTodo ? _ctx.selectedTodo.title : ''), 33))
                                    : (_openBlock(), _createBlock(_component_v_text_field, {
                                        key: 1,
                                        modelValue: _ctx.editedValue,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editedValue) = $event)),
                                        "single-line": "",
                                        onKeydown: [
                                          _withKeys(_ctx.updateField, ["enter"]),
                                          _withKeys(_ctx.cancelEditingField, ["esc"])
                                        ],
                                        onBlur: _ctx.cancelEditingField,
                                        ref: "editField",
                                        class: "mt-5 mr-5"
                                      }, null, 8, ["modelValue", "onKeydown", "onBlur"]))
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createVNode(_component_v_switch, {
                                  modelValue: _ctx.showCompletedTodoCheckboxes,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showCompletedTodoCheckboxes) = $event)),
                                  class: "d-flex align-center ml-3 mr-3"
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              (_ctx.selectedTodo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_component_v_select, {
                                      modelValue: _ctx.selectedTodo.importance,
                                      "onUpdate:modelValue": [
                                        _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedTodo.importance) = $event)),
                                        _ctx.updateImportance
                                      ],
                                      items: [
                                { text: 'Niedrig', value: 'low'},
                                { text: 'Mittel', value: 'medium'},
                                { text: 'Hoch', value: 'high'}
                            ],
                                      "item-title": "text",
                                      "item-value": "value",
                                      label: "Wichtigkeit"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.selectedTodo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.selectedTodo.due_date,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedTodo.due_date) = $event)),
                                      label: "Erledigt bis:",
                                      type: "date",
                                      onChange: _ctx.updateDueDate
                                    }, null, 8, ["modelValue", "onChange"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.selectedTodo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(_component_v_list, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unfinishedTodoCheckboxes, (checkbox) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: checkbox.id
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, {
                                                "no-gutters": "",
                                                align: "center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: checkbox.completed,
                                                        "onUpdate:modelValue": ($event: any) => ((checkbox.completed) = $event),
                                                        "hide-details": "",
                                                        onChange: ($event: any) => (_ctx.updateCheckbox(checkbox.id, checkbox.completed))
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                      (_ctx.editingField.type !== 'todoCheckboxEdit' || _ctx.editingField.id !== checkbox.id)
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 0,
                                                            onDblclick: ($event: any) => (_ctx.startEditingField('todoCheckboxEdit', checkbox ? checkbox.id : -1))
                                                          }, _toDisplayString(checkbox ? checkbox.title : ''), 41, _hoisted_11))
                                                        : (_ctx.editingField.type === 'todoCheckboxEdit' && _ctx.editingField.id === checkbox.id)
                                                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                              key: 1,
                                                              modelValue: _ctx.editedValue,
                                                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editedValue) = $event)),
                                                              "single-line": "",
                                                              onKeydown: [
                                                                _withKeys(_ctx.updateField, ["enter"]),
                                                                _withKeys(_ctx.cancelEditingField, ["esc"])
                                                              ],
                                                              onBlur: _ctx.cancelEditingField,
                                                              ref_for: true,
                                                              ref: "editField",
                                                              class: "mt-5 mr-5"
                                                            }, null, 8, ["modelValue", "onKeydown", "onBlur"]))
                                                          : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.newTodoCheckbox,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newTodoCheckbox) = $event)),
                                label: "Neuer Punkt",
                                "prepend-inner-icon": "mdi-plus",
                                variant: "underlined",
                                onKeydown: _withKeys(_ctx.createTodoCheckbox, ["enter"])
                              }, null, 8, ["modelValue", "onKeydown"]),
                              (_ctx.selectedTodo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_component_v_select, {
                                      modelValue: _ctx.selectedTodo.assigned_users,
                                      "onUpdate:modelValue": [
                                        _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedTodo.assigned_users) = $event)),
                                        _ctx.updateAssignedUser
                                      ],
                                      items: _ctx.usersWithPermissions,
                                      "item-title": "username",
                                      "item-value": "id",
                                      label: "Zugewiesen an",
                                      chips: "",
                                      multiple: ""
                                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
                                    _createVNode(_component_v_textarea, {
                                      label: "Informationen",
                                      modelValue: _ctx.selectedTodo.description,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedTodo.description) = $event)),
                                      onChange: _ctx.updateDescription
                                    }, null, 8, ["modelValue", "onChange"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}